import { PaymentInvoice, sumAmounts } from './utils'
import { SECTION_TYPES } from 'containers/Warehouse'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import Payments from 'components/Payments'
import React from 'react'

interface PaymentsProps {
  invoices: PaymentInvoice[]
  selectedData: payments.SelectedData
  additionalElement?: React.ReactNode
  summaryTop?: string
  /** remotePaymentId jest ustawione, gdy platnosc zostala zlecona */
  close: (remotePaymentId?: string) => void
}

const PaymentsContainer: React.FC<PaymentsProps> = ({ invoices, selectedData, additionalElement, summaryTop, close }) => {
  const { t } = useTranslation('warehouse')
  const { id } = useParams<warehouse.PageParams>()
  const amount = sumAmounts(invoices.map(invoice => invoice.amount))

  return (
    <Payments
      grossPrice={amount}
      summaryTop={summaryTop ?? t('resignationType.termination')}
      summaryBottom={selectedData.date}
      additionalElement={<>{additionalElement}</>}
      returnPath={`/warehouses/${id}/${SECTION_TYPES.invoices}`}
      getInvoices={async () => invoices}
      close={close}
    />
  )
}

export default PaymentsContainer
